export default "__VITE_ASSET__PkxF29z2t0BRBBUgt983$A__"